import { mapGetters } from 'vuex';

export default {
  props: {
    disabled: { type: Boolean },
    iconOnly: { type: Boolean, default: false },
    noBorder: { type: Boolean, default: false },
    buttonCopy: { typpe: String },
    buttonIcon: { type: String },
    to: {},
  },
  methods: {
    handleButtonClick() {
      if (this.disabled) {
        return;
      }
      this.$emit('click');
    },
  },
  computed: {
    ...mapGetters('windowMedia', [
      'isTouchCentric',
    ]),
  }
};
